export enum InstrumentationProvider {
  Baselime = 'baselime',
  Sentry = 'sentry',
}
